// ----------------------------------------------------------------------

export default function Typography(theme) {
    return {
        MuiTypography: {
            defaultProps: {
                variantMapping: {
                    label: 'label'
                }
            },
            styleOverrides: {
                paragraph: {
                    marginBottom: theme.spacing(2),
                },
                gutterBottom: {
                    marginBottom: theme.spacing(1),
                },
                label: {
                    fontWeight: 600
                }
            },
        },
    };
}
